"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledIMG = exports.StyledQRBox = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.StyledQRBox = styled_components_1.default.div `
  text-align: center;
`;
exports.StyledIMG = styled_components_1.default.img `
  width: 120px;
  height: 120px;
`;
